import styled from 'styled-components'

import { customMedia } from '@/styles/common/common'

export const DimBG = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
`
export const DimWrap = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  bottom: 70px;

  ${customMedia.lessThan('tablet')`
    bottom: 50px;
  `}
  ${customMedia.lessThan('tablet_cut_line')`
    bottom: 30px;
  `}
`
export const BtnWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  ${customMedia.lessThan('tablet_cut_line')`
    gap: 16px;
  `}
`
export const Button = styled.button<{ bgImgSrc: string }>`
  background-size: cover;
  background-image: url(${(props) => props.bgImgSrc});
  background-repeat: no-repeat;
  background-position: center;

  border: none;

  &:active {
    -webkit-tap-highlight-color: transparent;
  }

  &.store {
    width: 228px;
    height: 80px;

    border-radius: 18px;

    ${customMedia.lessThan('tablet_cut_line')`
      width: 142px;
      height: 54px;
    
      border-radius: 12px; 
    `}
  }

  &.delete {
    width: 50px;
    height: 50px;

    border-radius: 300px;

    ${customMedia.lessThan('tablet_cut_line')`
      width: 40px;
      height: 40px;
    `}
  }
`
